import { createStore } from 'vuex'
import user from './modules/user.js'
import menu from './modules/menu.js'
import layout from './modules/layout.js'
import dict from './modules/dict.js'
import tagsView from './modules/tagsView.js'

export default createStore({
  state: {

  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    menu,
    layout,
    dict,
    tagsView
  }
})
